<template>
  <div class="header">
    <div class="header-left">
      <span>系统管理</span>
    </div>
    <div class="header-right">
      <div v-if="isIndustry" class="icon-area" @click="toIndustry">
        <i class="iconfont mb-icon-assist-center"></i> 
        企联协作
        <i class="iconfont mb-icon-jump"></i>
      </div>
      <div v-if="isSuper" class="icon-area" @click="toBuild">
        <i class="iconfont mb-icon-design-center"></i> 
        构建中心
        <i class="iconfont mb-icon-jump"></i>
      </div>
      <div v-if="isIndustry || isSuper" class="split-line"></div>
      <div class="icon">
        <message-icon category="saas"></message-icon>
      </div>      
      <div class="avatar"><avatar-icon /></div>
    </div>
  </div>
</template>
<script>
import MessageIcon from '@/components/Message/Icon'
import AvatarIcon from '@/components/Avatar/Icon'

export default {
  name: 'framepage-header',  
  components: {
    MessageIcon,
    AvatarIcon
  },
  data() {
    return {
      regionConfig: [],
      isSuper: false,
    }
  },
  computed: {
    isIndustry() { // er_std
      return this.isSuper && this.regionConfig
        && ((this.regionConfig.versionPackage 
            && this.regionConfig.versionPackage.versionType == 'er_std')
          || (this.regionConfig.profile && this.regionConfig.profile.eaService))
    },   
  },
  created() {
    this.isSuper = this.$store.getters.isSuper
    this.regionConfig = this.$store.getters.regionConfig
  },
  methods: {
    switchAsideCollapse () {
      this.$store.commit('common/switchAsideCollapse')
    },
    toBuild() {
      window.open(location.origin + `/build.html`)
    },
    toIndustry() {
      window.open(location.origin + `/industry.html`)
    },
  },
}
</script>

<style scope>
.header,
.header-left,
.header-right {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-right .icon {
  margin: 0 20px 0 40px;
}
.header-right .icon .icon-item {
  height: 60px;
  line-height: 60px;
  font-size: 20px;
  color: #7891BE;
  cursor: pointer;
}
.header-right .split-line{
  width: 1px;
  height: 24px;
  margin-left: 10px;
  margin-right: 20px;
  background-color: #CED5D5;
}
.icon-area{
  display: flex;
  align-items: center;
  line-height: 16px;
  padding: 10px 0 10px 10px;
  color: #899897;
  cursor: pointer;
  border-radius: 5px;
}
.icon-area i{
  margin-right: 7px;
  color: #7891BE;
}
.icon-area:hover{
  background-color: #E8F8F3;
  color: #00C185;
}
.icon-area:hover i {
  color: #00C185;
}
i.mb-icon-jump{
  margin-left: 2px;
  font-size: 16px;
  transform: scale(0.5);
  visibility: hidden;
}
.icon-area:hover i.mb-icon-jump {
  color: #7891BE;
  visibility: visible;
}
</style>